// extracted by mini-css-extract-plugin
export default {"boxStyle":"ResumeBox_boxStyle__iaBVz","body":"ResumeBox_body__2iFUk","sectionIcon":"ResumeBox_sectionIcon__ZX38M"};